export const ModelBasePath = (window['ModelBasePath'] ? window['ModelBasePath'] : './');